import React from 'react';

import { CarouselElement } from '../../../element/carousel-element';
import type { CarouselElementType, PersonElementType } from '../../../types';
import { useLuminaSubAgentContext } from '../../lumina-sub-agents-context';
import type { RelatedPeopleData } from '../../types';
import { getSubAgentData } from '../utils';

export const RelatedPeople = ({
	isStreaming = false,
}: {
	isStreaming?: boolean;
}): React.JSX.Element | null => {
	const { luminaSubAgentResponse } = useLuminaSubAgentContext();
	const relatedPeople = getSubAgentData(luminaSubAgentResponse, 'ENTITY_RELATED_PEOPLE');
	if (!relatedPeople?.data) {
		return null;
	}

	try {
		const relatedPeopleData: RelatedPeopleData = JSON.parse(relatedPeople.data);
		const relatedPeopleCarouselChildren: PersonElementType[] = relatedPeopleData.people.map(
			(person) => ({
				tag: 'people-card',
				attributes: {
					name: person.name,
					job_title: person.jobTitle,
					avatar_url: person.avatarUrl,
					url: person.url,
				},
			}),
		);

		if (!relatedPeopleCarouselChildren.length) {
			return null;
		}

		const relatedPeopleCarouselComponent: CarouselElementType = {
			tag: 'carousel',
			attributes: {
				title: 'Related People',
			},
			children: relatedPeopleCarouselChildren,
		};

		return (
			<CarouselElement
				component={relatedPeopleCarouselComponent}
				position="two-rows-bottom"
				isStreaming={isStreaming}
			/>
		);
	} catch {
		return null;
	}
};
